<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="deliveryBills"
        :search-more-show="true"
        @select="select"
        @select-all="select"
        @update:filter="handleClick"
        @searchShow="searchShowHandle"
      >
        <div slot="toolbar">
          <el-button v-if="limits.addAuth" type="primary" @click="$refs.editPage.open(0)">新建</el-button>
          <el-button v-if="limits.submitAuth" :disabled="!selection.length" type="primary" @click="suspend">提交</el-button>
          <el-button v-if="limits.cancelAuth" :disabled="!selection.length" type="primary" @click="cancelSuspend">撤销</el-button>
          <el-button v-if="limits.printAuth" :disabled="!selection.length" type="primary" @click="printPurchaseReceivingOrder"
            >打印收货单</el-button
          >
          <el-upload
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="onUploadSuccess"
            :show-file-list="false"
            :headers="uploadHeaders"
            accept=".xlsx"
            :disabled="importLoading"
            style="display: inline-block; margin: 0 5px 0 5px"
          >
            <el-button v-if="limits.importAuth" type="primary" :loading="importLoading">导入</el-button>
          </el-upload>
          <el-button type="primary" @click="downloadTemplate">下载导入模板</el-button>
          <el-button :disabled="!selection.length" type="danger" @click="deleteRows">批量删除</el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="收货单号：">
              <el-input v-model="filter.billNO" placeholder="请输入收货单号" clearable />
            </vm-search>
            <vm-search label="采购订单：">
              <el-input v-model="filter.purchaseOrderNo" placeholder="请输入采购订单编号" clearable />
            </vm-search>
            <vm-search label="供应商：" :label-width="65">
              <el-input v-model="filter.supplierName" placeholder="请输入供应商名称" clearable />
            </vm-search>
          </div>
          <div v-show="searchShow">
            <vm-search label="订单状态：">
              <el-select v-model="filter.status" clearable>
                <el-option label="未提交" :value="0" />
                <el-option label="已提交" :value="1" />
                <el-option label="已入库" :value="2" />
              </el-select>
            </vm-search>
            <vm-search label="收货时间：">
              <div class="block">
                <el-date-picker
                  v-model="receiptTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  style="width: 100%"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="receiptTimeChange"
                />
              </div>
            </vm-search>
            <vm-search label="制单时间：">
              <div class="block">
                <el-date-picker
                  v-model="createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  style="width: 100%"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="createTimeChange"
                />
              </div>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" label="#" align="center" width="55" prop="selection" />
        <el-table-column prop="billNO" label="收货单号" align="center" width="150" />
        <el-table-column prop="purchaseOrderNo" label="采购订单编号" align="center" width="150" />
        <el-table-column prop="supplierName" label="供应商" align="left" min-width="200" />
        <el-table-column prop="receiptTime" label="收货时间" align="center" width="150" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">未提交</span>
            <span v-else-if="scope.row.status === 1">已提交</span>
            <span v-else-if="scope.row.status === 2">已入库</span>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" label="制单人" align="center" width="100" />
        <el-table-column prop="createTime" label="制单时间" align="center" width="150" />
        <el-table-column label="操作" fixed="right" align="center" width="240" prop="action">
          <template slot-scope="scope">
            <el-button
              v-if="limits.editAuth"
              type="primary"
              :disabled="scope.row.status === 2 || scope.row.status === 1"
              @click="$refs.editPage.open(scope.row.pkid)"
              >编辑</el-button
            >
            <el-button type="warning" @click="$refs.editPage.open(scope.row.pkid, true)"> 详情 </el-button>
            <el-button
              v-if="limits.printAuth"
              type="primary"
              :disabled="scope.row.status === 0"
              @click="$refs.printPage.open(scope.row.pkid)"
              >打印条码</el-button
            >
            <el-button
              v-if="limits.delAuth"
              type="danger"
              :disabled="scope.row.status === 2 || scope.row.status === 1"
              @click="deleteRow(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </vm-table>
      <purchase-receiving-edit ref="editPage" @save-success="getList(1)" />
      <pur-chase-reciving-details ref="printPage" />
    </el-main>
  </el-container>
</template>

<script>
import VmSearch from "@/components/VmSearch";
import VmTable from "@/components/VmTable";
import PurchaseReceivingEdit from "./PurchaseReceivingEdit";
import PurChaseRecivingDetails from "./PurChaseRecivingDetails";
import loginUtil from "@/util/loginUtil";
export default {
  components: { VmTable, VmSearch, PurchaseReceivingEdit, PurChaseRecivingDetails },
  data() {
    return {
      limits: {
        addAuth: this.$auth(360),
        editAuth: this.$auth(361),
        delAuth: this.$auth(362),
        submitAuth: this.$auth(363),
        cancelAuth: this.$auth(364),
        importAuth: this.$auth(365),
        printAuth: this.$auth(366),
      },
      uploadUrl: window.config.basicServerUrl + "deliveryBills/import",
      uploadHeaders: { Authorization: loginUtil.getToken() },
      selection: [],
      searchShow: false,
      createTime: [],
      receiptTime: [],
      ids: [],
      flag: true,
      importLoading: false,
      billStatus: [],
      filter: {
        billNO: "",
        purchaseOrderNo: "",
        supplierName: "",
        receiptTimeBegin: "",
        receiptTimeEnd: "",
        createTimeBegin: "",
        createTimeEnd: "",
        status: "",
      },
    };
  },
  mounted() {
    this.$refs.vmTable.getList(1);
  },

  methods: {
    getList(pageNum) {
      this.$refs.vmTable.getList(pageNum);
    },

    // 接收子组件vmtable传过来的值 是否显示更多的搜索条件
    searchShowHandle(val) {
      this.searchShow = val;
    },

    //制单时间
    createTimeChange(val) {
      if (val) {
        this.filter.createTimeBegin = val[0];
        this.filter.createTimeEnd = val[1];
      } else {
        this.filter.createTimeBegin = "";
        this.filter.createTimeEnd = "";
      }
    },

    //收货时间
    receiptTimeChange(val) {
      if (val) {
        this.filter.receiptTimeBegin = val[0];
        this.filter.receiptTimeEnd = val[1];
      } else {
        this.filter.receiptTimeBegin = "";
        this.filter.receiptTimeEnd = "";
      }
    },

    //订单提交
    suspend() {
      const arr = this.selection.filter((item) => item.status !== 0);
      if (arr.length) {
        this.$confirm("请选择未提交的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "deliveryBills/suspendByPkIds", ids).then(() => {
            this.getList(1);
            this.$message.success("提交成功");
          });
        });
      }
    },

    //撤销方法
    cancelSuspend() {
      const arr = this.selection.filter((item) => item.status !== 1);
      if (arr.length) {
        this.$confirm("请选择已提交的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定撤销吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "deliveryBills/cancelSuspendByPkIds", ids).then(() => {
            this.getList(1);
            this.$message.success("撤销成功");
          });
        });
      }
    },

    //选择
    select(selection) {
      this.selection = selection;
    },

    printPurchaseReceivingOrder() {
      const arr = this.selection.filter((item) => item.status !== 1);
      if (arr.length) {
        return this.$confirm("请选择已提交的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
      }
      let ids = [];
      this.selection.forEach((item) => {
        ids.push(item.pkid);
      });
      const routeUrl = this.$router.resolve({
        path: "/orderReceivingPrint",
        query: {
          params: ids,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 单个删除
    deleteRow(row) {
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.$http.delete("basic", "deliveryBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.getList(1);
            this.$message.success("删除成功");
          }
        });
      });
    },

    //批量删除
    deleteRows() {
      const arr = this.selection.filter((item) => item.status !== 0);
      if (arr.length) {
        this.$confirm("请选择未提交状态的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      let ids = [];
      this.selection.forEach((item) => {
        ids.push(item.pkid);
      });
      this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
        this.$http.post("basic", "deliveryBills/deleteByPkIds", ids).then(() => {
          this.getList(1);
          this.$message.success("删除成功");
        });
      });
    },

    // 点击重置需要重置日期查询(注意)
    handleClick() {
      this.receiptTime = [];
      this.createTime = [];
    },

    downloadTemplate() {
      window.open("/file/采购收货导入模板.xlsx", "_self");
    },

    beforeUpload(file) {
      let fileName = file.name;
      let index = fileName.lastIndexOf(".");
      let lastName = fileName.substring(index, fileName.length);
      if (lastName.toLowerCase() !== ".xlsx") {
        this.$message.error("请上传.xlsx文件类型");
        return false;
      }
      this.importLoading = true;
      return true;
    },

    onUploadSuccess(res) {
      if (res.success) {
        this.$message.success("导入成功");
        this.getList(1);
      } else {
        this.$confirm(res.message, "错误", {
          type: "error",
          showCancelButton: false,
        });
      }
      this.importLoading = false;
    },
  },
};
</script>

<style></style>
